import React from 'react';
import { useIntl } from 'react-intl';

const CallToAction = () => {
  const intl = useIntl();

  const scrollToGame = () => {
    const gameElement = document.getElementById('game-area');
    if (gameElement) {
      gameElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-indigo-600 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">{intl.formatMessage({ id: 'home.callToAction.title' })}</h2>
        <p className="text-xl mb-8">{intl.formatMessage({ id: 'home.callToAction.description' })}</p>
        <button 
          className="bg-white text-indigo-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-100 transition duration-300"
          onClick={scrollToGame}
        >
          {intl.formatMessage({ id: 'home.callToAction.button' })}
        </button>
      </div>
    </section>
  );
};

export default CallToAction;